import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35aa1e2d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "modal",
    "data-action": "<%action%>",
    tabindex: "-1",
    role: "dialog",
    id: "modal-galeria",
    "data-backdrop": "static",
    "data-keyboard": "false"
};
const _hoisted_2 = { class: "modal-dialog" };
const _hoisted_3 = { class: "modal-content" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-header" }, [
    /*#__PURE__*/ _createElementVNode("h5", { class: "modal-title" }, "Galeria")
], -1));
const _hoisted_5 = { class: "modal-body" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "alert alert-info" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "far fa-lightbulb" }),
    /*#__PURE__*/ _createTextVNode(" Você pode escolher até 3 imagens ou vídeos do youtube para ilustrar a galeria de sua campanha. ")
], -1));
const _hoisted_8 = { id: "lista-vitrines-container" };
const _hoisted_9 = ["alt"];
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-arrows-alt-h text-danger" }, null, -1));
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1));
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = { id: "lista-vitrines-actions-container" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-plus" }, null, -1));
const _hoisted_18 = ["disabled"];
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-plus" }, null, -1));
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "alert alert-info" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-info-circle" }),
    /*#__PURE__*/ _createTextVNode(" Enquadre a imagem e clique em Adicionar. ")
], -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { id: "cropjs-container" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        alt: "Vitrine",
        id: "cropperjs-img"
    })
], -1));
const _hoisted_22 = { id: "cropper-actions-container" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search-minus" }, null, -1));
const _hoisted_24 = [
    _hoisted_23
];
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search-plus" }, null, -1));
const _hoisted_26 = [
    _hoisted_25
];
const _hoisted_27 = { key: 1 };
const _hoisted_28 = { class: "row" };
const _hoisted_29 = { class: "col-sm-12" };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, [
    /*#__PURE__*/ _createTextVNode(" Link do vídeo do Youtube "),
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fa fa-info-circle",
        title: "Informe o link para o seu vídeo no Youtube."
    })
], -1));
const _hoisted_31 = { class: "modal-footer" };
const _hoisted_32 = { key: 0 };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-dismiss": "modal"
}, " Salvar ", -1));
const _hoisted_34 = [
    _hoisted_33
];
const _hoisted_35 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_draggable = _resolveComponent("draggable");
    const _component_DialogButton = _resolveComponent("DialogButton");
    const _component_FileSelector = _resolveComponent("FileSelector");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                    (_ctx.action === 'inicial')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _hoisted_7,
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", {
                                    id: "lista-vitrines",
                                    class: _normalizeClass(_ctx.predrag ? 'is-dragging' : '')
                                }, [
                                    _createVNode(_component_draggable, {
                                        modelValue: _ctx.campanha.vitrines,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.campanha.vitrines) = $event)),
                                        group: "vitrines",
                                        onStart: _cache[3] || (_cache[3] = ($event) => (_ctx.drag = true)),
                                        onEnd: _cache[4] || (_cache[4] = ($event) => (_ctx.drag = false)),
                                        "item-key": "id",
                                        handle: ".btn-reorganizar"
                                    }, {
                                        item: _withCtx(({ element, index }) => [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["vitrine-item", 'vitrine-' + element.tipo])
                                            }, [
                                                _createElementVNode("div", {
                                                    class: "img",
                                                    style: _normalizeStyle('background-image: url(' +
                                                        (element.tipo === 'imagem'
                                                            ? element.data_src
                                                            : 'http://img.youtube.com/vi/' +
                                                                element.data_src +
                                                                '/0.jpg') +
                                                        ');'),
                                                    alt: 'Vitrine ' + (index + 1)
                                                }, null, 12, _hoisted_9),
                                                (element.tipo === 'youtube')
                                                    ? (_openBlock(), _createElementBlock("iframe", {
                                                        key: 0,
                                                        src: 'https://www.youtube.com/embed/' + element.data_src,
                                                        frameborder: "0",
                                                        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                                        allowfullscreen: ""
                                                    }, null, 8, _hoisted_10))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", {
                                                    class: "btn btn-default btn-reorganizar btn-xs btn-sm shadow-none",
                                                    title: "Reorganizar",
                                                    onMouseenter: _cache[0] || (_cache[0] = ($event) => (_ctx.predrag = true)),
                                                    onMouseleave: _cache[1] || (_cache[1] = ($event) => (_ctx.predrag = false))
                                                }, _hoisted_12, 32),
                                                _createElementVNode("div", {
                                                    class: "btn btn-danger btn-rm btn-xs btn-sm shadow-none",
                                                    title: "Remover",
                                                    onClick: ($event) => (_ctx.rmVitrine(index))
                                                }, _hoisted_15, 8, _hoisted_13)
                                            ], 2)
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"])
                                ], 2)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_FileSelector, {
                                    modelValue: _ctx.imagesTemp,
                                    "onUpdate:modelValue": [
                                        _cache[5] || (_cache[5] = ($event) => ((_ctx.imagesTemp) = $event)),
                                        _cache[6] || (_cache[6] = ($event) => (_ctx.onAddImages()))
                                    ],
                                    allowMultiple: false,
                                    accept: ['image/*']
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_DialogButton, {
                                            class: "btn btn-primary shadow-none",
                                            disabled: _ctx.limiteVitrinesAlcancado
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_17,
                                                _createTextVNode(" Adicionar Imagem ")
                                            ]),
                                            _: 1
                                        }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"]),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary shadow-none",
                                    onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.novoVideo())),
                                    disabled: _ctx.limiteVitrinesAlcancado
                                }, [
                                    _hoisted_19,
                                    _createTextVNode(" Adicionar Vídeo do YouTube ")
                                ], 8, _hoisted_18)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.action !== 'nova-imagem' ? 'hide' : '')
                    }, [
                        _hoisted_20,
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary shadow-none",
                                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.onChangeZoomSlider('-')))
                            }, _hoisted_24),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary shadow-none",
                                onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.onChangeZoomSlider('+')))
                            }, _hoisted_26)
                        ])
                    ], 2),
                    (_ctx.action === 'novo-video')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    _hoisted_30,
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.novoVideoCtrl.url) = $event)),
                                        maxlength: "255"
                                    }, null, 512), [
                                        [_vModelText, _ctx.novoVideoCtrl.url]
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_31, [
                    (_ctx.action === 'inicial')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_34))
                        : _createCommentVNode("", true),
                    (_ctx.action !== 'inicial')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary mr-2",
                                onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.irParaInicial()))
                            }, " Voltar "),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.adicionar()))
                            }, " Adicionar ")
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
